// Returns the Firebase Functions base URL based on environment
export function getFunctionsBaseUrl() {
  return import.meta.env.DEV
    ? 'http://localhost:5001/dagslys-dc425/europe-west1'
    : 'https://europe-west1-dagslys-dc425.cloudfunctions.net';
}


